export const LOAD_POKEMONS_START = 'LOAD_POKEMONS_START';
export const LOAD_POKEMONS_READY = 'LOAD_POKEMONS_READY';
export const LOAD_POKEMONS_ERROR = 'LOAD_POKEMONS_ERROR';

export const LOAD_POKEMONS_DETAILS_START = 'LOAD_POKEMONS_DETAILS_START';
export const LOAD_POKEMONS_DETAILS_READY = 'LOAD_POKEMONS_DETAILS_READY';
export const LOAD_POKEMONS_DETAILS_ERROR = 'LOAD_POKEMONS_DETAILS_ERROR';


export const LOAD_POKEMON_DETAILS_START = 'LOAD_POKEMON_DETAILS_START';
export const LOAD_POKEMON_DETAILS_READY = 'LOAD_POKEMON_DETAILS_READY';
export const LOAD_POKEMON_DETAILS_ERROR = 'LOAD_POKEMON_DETAILS_ERROR';


export const LOAD_SINGLE_POKEMON_START = 'LOAD_SINGLE_POKEMON_START';
export const LOAD_SINGLE_POKEMON_READY = 'LOAD_SINGLE_POKEMON_READY';
export const LOAD_SINGLE_POKEMON_ERROR = 'LOAD_SINGLE_POKEMON_ERROR';